/**
 * @generated SignedSource<<7480b5813e71e947657f66416e8eb77e>>
 * @relayHash 3d5107055d0ad5e5fed0e694feb80f1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5acb81487b5b5127dead4c25a310545e5437aad4717ee4c6f1d7a5a5a6c6614e

import type { ConcreteRequest } from 'relay-runtime';
export type DatabaseContainerQuery$variables = {
  contentId: string;
  contentVersion: number;
  spaceKey?: string | null;
};
export type DatabaseContainerQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors: ReadonlyArray<{
        readonly id: string | null;
        readonly status: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly hasInheritedRestrictions: boolean;
      readonly hasRestrictions: boolean;
      readonly hasViewRestrictions: boolean;
      readonly id: string | null;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly referenceId: string | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
        readonly type: string | null;
      } | null;
      readonly status: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly dataSecurityPolicy: {
    readonly isDownloadAllowed: {
      readonly allowed: boolean | null;
    };
    readonly isExportAllowed: {
      readonly allowed: boolean | null;
    };
  } | null;
  readonly spaces: {
    readonly nodes: ReadonlyArray<{
      readonly homepage: {
        readonly id: string | null;
      } | null;
      readonly id: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly space: {
        readonly id: string | null;
      } | null;
    } | null;
    readonly displayName: string | null;
    readonly emails: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
    readonly id: string | null;
    readonly locale: string | null;
    readonly photos: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
};
export type DatabaseContainerQuery = {
  response: DatabaseContainerQuery$data;
  variables: DatabaseContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentVersion"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "status"
},
v8 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v9 = [
  (v3/*: any*/)
],
v10 = [
  {
    "kind": "ScalarField",
    "name": "value"
  },
  {
    "kind": "ScalarField",
    "name": "isPrimary"
  }
],
v11 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v12 = {
  "kind": "Literal",
  "name": "contentStatus",
  "value": "CURRENT"
},
v13 = {
  "kind": "Variable",
  "name": "contentVersion",
  "variableName": "contentVersion"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "allowed"
  }
],
v15 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "referenceId"
          },
          (v4/*: any*/),
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "hasRestrictions"
          },
          {
            "kind": "ScalarField",
            "name": "hasViewRestrictions"
          },
          {
            "kind": "ScalarField",
            "name": "hasInheritedRestrictions"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "alias"
              }
            ]
          },
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "ancestors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v6/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      (v8/*: any*/)
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": (v9/*: any*/)
          }
        ]
      }
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": (v10/*: any*/)
      },
      {
        "concreteType": "AtlassianUserEmail",
        "kind": "LinkedField",
        "name": "emails",
        "plural": true,
        "selections": (v10/*: any*/)
      },
      {
        "kind": "ScalarField",
        "name": "locale"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": (v9/*: any*/)
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  },
  {
    "concreteType": "Confluence_dataSecurityPolicy",
    "kind": "LinkedField",
    "name": "dataSecurityPolicy",
    "plural": false,
    "selections": [
      {
        "alias": "isExportAllowed",
        "args": [
          {
            "kind": "Literal",
            "name": "action",
            "value": "PAGE_EXPORT"
          },
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v8/*: any*/)
        ],
        "concreteType": "DataSecurityPolicyDecision",
        "kind": "LinkedField",
        "name": "isActionEnabledForContent",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "alias": "isDownloadAllowed",
        "args": [
          {
            "kind": "Literal",
            "name": "action",
            "value": "ATTACHMENT_DOWNLOAD"
          },
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v8/*: any*/)
        ],
        "concreteType": "DataSecurityPolicyDecision",
        "kind": "LinkedField",
        "name": "isActionEnabledForContent",
        "plural": false,
        "selections": (v14/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DatabaseContainerQuery",
    "selections": (v15/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "DatabaseContainerQuery",
    "selections": (v15/*: any*/)
  },
  "params": {
    "cacheID": "3d5107055d0ad5e5fed0e694feb80f1c",
    "id": "5acb81487b5b5127dead4c25a310545e5437aad4717ee4c6f1d7a5a5a6c6614e",
    "metadata": {},
    "name": "DatabaseContainerQuery",
    "operationKind": "query",
    "text": "query DatabaseContainerQuery($contentId:ID!,$spaceKey:String,$contentVersion:Int!){content(id:$contentId){nodes{id,referenceId,title,operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status}}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},emails{value,isPrimary},locale,confluence{space{id}}},dataSecurityPolicy{isExportAllowed:isActionEnabledForContent(action:PAGE_EXPORT,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed},isDownloadAllowed:isActionEnabledForContent(action:ATTACHMENT_DOWNLOAD,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed}}}"
  }
};
})();

(node as any).hash = "7a60e16be16d4c46e03e2f2d23d9dc89";

export default node;
